const PropTypes = require('prop-types');

//eslint-disable-next-line no-unused-vars
const DataTableColumn = ({ dataKey, format, header }) => null;

DataTableColumn.propTypes = {
    dataKey: PropTypes.string,
    format: PropTypes.func,
    header: PropTypes.string,
};

module.exports = DataTableColumn;
